import React from 'react';
import { Form, Input, Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { FormInstance } from 'antd/lib/form';
import { register } from '../../api';
import styles from './index.module.css';

const RegistrationForm: React.FC = () => {
    const formRef = React.createRef<FormInstance>();
    const navigate = useNavigate();

    const onFinish = async (values: any) => {
        await register(values.username, values.email, values.password, values.agencyName);
        console.log('Received values of form: ', values);
        navigate('/login');
    };

    return (
        <div className={styles.container}>
            <div style={{
                backgroundColor: '#ffffff',
                padding: '40px',
                borderRadius: '16px',
                boxShadow: '0 8px 32px rgba(0, 0, 0, 0.15)',
                maxWidth: '420px',
                width: '100%',
            }}>
                <h2 style={{ 
                    textAlign: 'center',
                    marginBottom: '32px',
                    fontSize: '26px',
                    fontWeight: '700',
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                }}>註冊帳號</h2>
                <Form
                    ref={formRef}
                    name="register"
                    onFinish={onFinish}
                    initialValues={{
                        username: '',
                        email: '',
                        password: '',
                        agencyName: '',
                        confirm: '',
                    }}
                    scrollToFirstError
                >
                    <Form.Item
                        name="username"
                        rules={[
                            {
                                required: true,
                                message: '請輸入用戶名稱！',
                                whitespace: true,
                            },
                        ]}
                    >
                        <Input placeholder="用戶名稱" size="large" />
                    </Form.Item>

                    <Form.Item
                        name="email"
                        rules={[
                            {
                                type: 'email',
                                message: '請輸入有效的電郵地址！',
                            },
                            {
                                required: true,
                                message: '請輸入電郵地址！',
                            },
                        ]}
                    >
                        <Input placeholder="電郵地址" size="large" />
                    </Form.Item>

                    <Form.Item
                        name="password"
                        rules={[
                            {
                                required: true,
                                message: '請輸入密碼！',
                            },
                        ]}
                        hasFeedback
                    >
                        <Input.Password placeholder="密碼" size="large" />
                    </Form.Item>

                    <Form.Item
                        name="agencyName"
                        rules={[
                            {
                                required: true,
                                message: '請輸入旅行社名稱！',
                            },
                        ]}
                    >
                        <Input placeholder="旅行社名稱" size="large" />
                    </Form.Item>

                    <Form.Item
                        name="confirm"
                        dependencies={['password']}
                        hasFeedback
                        rules={[
                            {
                                required: true,
                                message: '請確認密碼！',
                            },
                            ({ getFieldValue }) => ({
                                validator(_, value) {
                                    if (!value || getFieldValue('password') === value) {
                                        return Promise.resolve();
                                    }
                                    return Promise.reject(new Error('兩次輸入的密碼不一致！'));
                                },
                            }),
                        ]}
                    >
                        <Input.Password placeholder="確認密碼" size="large" />
                    </Form.Item>

                    <Form.Item>
                        <Button 
                            type="primary" 
                            htmlType="submit"
                            style={{ 
                                width: '100%',
                                height: '44px',
                                fontSize: '16px',
                                fontWeight: '600',
                                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                border: 'none',
                                boxShadow: '0 4px 12px rgba(102, 126, 234, 0.4)',
                            }}
                        >
                            註冊
                        </Button>
                    </Form.Item>
                    
                    <Form.Item style={{ marginBottom: 0, textAlign: 'center' }}>
                        <Button 
                            type="link" 
                            onClick={() => navigate('/login')}
                            style={{ 
                                color: '#667eea',
                                fontWeight: '500',
                            }}
                        >
                            已有帳號？立即登入
                        </Button>
                    </Form.Item>
                </Form>
            </div>
        </div>
    );
};

export default RegistrationForm;